import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "../Layout/Header/Header";
import FooterCopy from '../Footer/FooterCopy';


const ProfileLayout = () => {
    return (
        <div>
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* HEADER */}
                <Header />

                {/* CONTENT */}
                <Box sx={{ flexGrow: 1 }}>
                    <Container maxWidth="xl" sx={{ pt: { xs: "90px", md: "100px" } }}>
                        <Outlet />
                    </Container>
                </Box>

                {/* FOOTER */}
                <FooterCopy />
            </Box>
        </div>
    )
}

export default ProfileLayout;